<template>
  <div class="animated fadeIn">
      <b-card>
        <b-row>
          <b-col md="2">
            <b-form-group>
              * Please Set Range
            </b-form-group>
          </b-col>
          <b-col md="5">
            <b-form-group>
              <b-form>
              <label for="opt_date">From </label>
                <date-picker style="width: 300px" v-model="From" :lang="custom.lang.en" :first-day-of-week="1" @change="report"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="5">
            <b-form-group>
              <b-form>
              <label for="opt_date">To </label>
                <date-picker style="width: 300px" v-model="To" :lang="custom.lang.en" :first-day-of-week="1" @change="report"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <!-- <b-col md="1">
            <b-form-group>
              <b-form inline>
              <b-button size="sm" variant="primary" @click="report"> Search </b-button>
              </b-form>
            </b-form-group>
          </b-col> -->
        </b-row>
        <!-- <b-form-group class="float-right">
          <b-button size="sm" variant="primary" @click="report"> Search </b-button>
          <b-button size="sm" variant="secondary" @click="reset"> Initialization </b-button>
          <b-button size="sm" variant="success" id="excelHtml5" @click="printNow"> PRINT </b-button>
        </b-form-group> -->
      </b-card>
      <div style="display:block; margin-left:auto; margin-right:auto;"><br>
      <h1 align="center" style="font-weight:700; font-size:50px">WMDS Report</h1>
      </div>
      <img style="display:block; margin-left:auto; margin-right:auto;" src="../report/world_map.png"/>
      <b-card>
        <b-form-group>
        Copyrights<br><br>
        Copyright ⓒ 2019 F1Security Inc.<br>
        10F, #1003, 128, Gasan Digital 1-ro, Geumcheon-gu, Seoul, Korea (08507)<br>
        All Rights Reserved.<br><br>
        This report has been prepared to provide information on the results of malicious code check for the period to the person in charge of 'WMDS'<br>
        This document is copyrighted by F1Security Inc. Because it is copyrighted in Korea under copyright law<br>
        Reproduction in any manner whatsoever without permission is prohibited. Without the written consent of F1Security Inc.<br>
        Please note that we can not cite it in whole or in part. Unauthorized use may be subject to penalties under applicable law.<br>
        This document may contain technical inaccuracies or typographical errors.<br>
        Note) Please note that the contents of this document or the program can be modified or changed without prior notice.
        </b-form-group>
      </b-card>
       <b-form-group>
          <h4 style="page-break-before:always;">Index</h4>
        </b-form-group>
          <b-card>
            <b-form-group>
              1. Summary - Period Key Content Summary<br>
              1.1.{{model.name || 'WMDS'}} Information<br>
              1.2. Check Statistics Information<br>
              1.3. Check Statistics Information<br>
              <!-- 2.2. 탐지사이트 목록<br> -->
              1.4. Site Detect List<br>
              <!-- 2.3. 점검사이트 목록<br> -->
              1.5. Site Check List<br>
            <!-- &lt;표 1. 사이트 기본 정보&gt;<br> -->
            &lt;table 1. Site Basic Information&gt;<br>
            <!-- &lt;표 2. 점검 통계 정보&gt;<br> -->
            &lt;table 2. Check Statistics Information&gt;<br>
            <!-- &lt;표 3. 등급별 탐지 사이트 검출 통계표&gt;<br> -->
            <!-- &lt;표 4. 탐지사이트 목록&gt;<br> -->
            &lt;Table 4. Site Detect List&gt;<br>
            <!-- &lt;표 5. 점검사이트 목록&gt;<br> -->
            &lt;Table 5. Site Check List&gt;<br>
            </b-form-group>
          </b-card>
        <b-form-group>
          <h5>1. Summary - Period Key Content Summary</h5>
        </b-form-group>
         <b-form-group>
          <h5>1.1. User Registration Site Information</h5>
          <small>Basic information of user registration site. Next &lt;표 1.  Site Basic Information&gt;Through the site name, business name, site URL, FQDN, the number of registered domains (total).</small>
        </b-form-group>
          <b-card>
            <template slot="header">
               &lt;table 1.  Site Basic Information&gt;
            </template>
            <div class="panel-body">
              <div>
                <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr>
                      <th colspan="2" style="border-top:1px solid; padding:4px; background-Color:#cccccc; text-align: center;">Company Name</th>
                      <th colspan="2" style="padding:4px; background-Color:#f0f3f5; text-align: center;">{{user.groupname || 'WMDS'}}</th>
                    </tr>
                    <tr>
                      <th colspan="2" style="border-top:1px solid; padding:4px; background-Color:#cccccc; text-align: center;">Service</th>
                      <th colspan="2" style="border-top:1px solid; padding:4px; background-Color:#f0f3f5; text-align: center;">{{user.Service || 'WMDS'}}</th>
                    </tr>
                    <tr>
                      <th colspan="2" style="border-top:1px solid; padding:4px; background-Color:#cccccc; text-align: center;">Domain Count</th>
                      <th colspan="2" style="border-top:1px solid; padding:4px; background-Color:#f0f3f5; text-align: center;">{{site.use + site.unuse || 0}}</th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-card>
        <b-form-group>
          <h5>1.2. Check Statistics Information</h5>
          <small>Site check statistics information. Next &lt;table 3. Check Statistics Information&gt; Through this, you can check registered domain, number of detection page detection, site inspection, and number of detection rules.</small>
        </b-form-group>
        <b-card>
          <template slot="header">
             &lt;표 2. Check Statistics Information&gt;
          </template>
          <div style="width:100%; min-height: .01%; display: block;">
            <table style="width:100%; max-width:100%; margin-bottom:20px; border-spacing: 0; border-collapse: collapse; border: 1px solid; text-align:center;">
              <tbody>
                <tr style="padding: 4px; background-Color: #ccc text-align: center;">
                  <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">Registration Domain</th>
                  <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">Check Pages</th>
                  <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">Detect Pages</th>
                  <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">Detect Pattern(System)</th>
                  <th style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">Detect Pattern(User)</th>
                </tr>
                <tr class="right2">
                  <td style="border: 1px solid;">[use : {{site.use || 0}} ]</td>
                  <td style="border: 1px solid;">[Internal pages  : {{result.total_page || 0}} ]</td>
                  <td style="border: 1px solid;">[URL : {{ detect.U || 0}} ]</td>
                  <td style="border: 1px solid;">[URL : {{ pattern.system.U || 0}} ]</td>
                  <td style="border: 1px solid;">[URL : {{ pattern.user.U || 0}} ]</td>
                </tr>
                <tr class="right2">
                  <td style="border: 1px solid;">[unuse : {{site.unuse || 0}} ]</td>
                  <td style="border: 1px solid;">[External pages : {{result.total_ext || 0}} ]</td>
                  <td style="border: 1px solid;">[String : {{ detect.S || 0}} ]</td>
                  <td style="border: 1px solid;">[String : {{ pattern.system.S || 0}} ]</td>
                  <td style="border: 1px solid;">[String : {{ pattern.user.S || 0}} ]</td>
                </tr>
                <tr class="right2">
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;">[Detect pages : {{result.total_detect || 0}} ]</td>
                  <td style="border: 1px solid;">[Hash : {{ detect.H|| 0}} ]</td>
                  <td style="border: 1px solid;">[Hash : {{ pattern.system.H || 0}} ]</td>
                  <td style="border: 1px solid;">[Hash : {{ pattern.user.H || 0}} ]</td>
                </tr>
                <tr class="right2">
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;">[Error pages : {{result.total_error || 0}} ]</td>
                  <td style="border: 1px solid;">[Regex : {{ detect.R|| 0}} ]</td>
                  <td style="border: 1px solid;">[Regex : {{ pattern.system.R || 0}} ]</td>
                  <td style="border: 1px solid;">[Regex : {{ pattern.user.R || 0}} ]</td>
                </tr>
                <tr class="right2">
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;">[binary pages : {{result.total_binary || 0}} ]</td>
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                  <td style="border: 1px solid;"></td>
                </tr>
                <tr style="padding: 4px; background-Color: #ccc text-align: center;">
                  <td style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">
                    <b>Total : {{site.use + site.unuse || 0}}</b>
                  </td>
                  <td style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">
                    <b>Total : {{result.total_page + result.total_ext + result.total_detect || 0}}</b>
                  </td>
                  <td style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">
                    <b>Total : {{detect.U + detect.S + detect.H + detect.R || 0}}</b>
                  </td>
                  <td style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">
                    <b>Total : {{ pattern.system.U + pattern.system.S + pattern.system.H + pattern.system.R || 0}}</b>
                  </td>
                  <td style=" width:180px; padding:4px; background-Color:#cccccc; text-align: center; border: 1px solid;">
                    <b>Total : {{ pattern.user.U + pattern.user.S + pattern.user.H + pattern.user.R || 0}}</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-card>
     <b-card>
      <template slot="header">
         &lt;picture 1. Check statistics graph&gt;
      </template>
      <b-row>
        <b-col sm="6" lg="3">
          <h6 class="mb-0">Regist Domain</h6>
          <card-bar-chart class="chart-wrapper px-3" style="height:150px;" :options="bar_opt" :chart-data="use_data"/>
        </b-col>
        <b-col sm="6" lg="3">
          <h6 class="mb-0">Check Page Count</h6>
          <card-bar-chart class="chart-wrapper px-3" style="height:150px;" :options="bar_opt" :chart-data="result_data"/>
        </b-col>
        <b-col sm="6" lg="3">
          <h6 class="mb-0">Detect Page Count</h6>
          <card-bar-chart class="chart-wrapper px-3" style="height:150px;" :options="bar_opt" :chart-data="detect_data"/>
        </b-col>
        <b-col sm="6" lg="3">
          <h6 class="mb-0">Detect Pattern</h6>
          <card-bar-chart class="chart-wrapper px-3" style="height:150px;" :options="bar_opt" :chart-data="rule_data"/>
        </b-col>
      </b-row>
      </b-card>
      <b-form-group>
        <h5>1.4. Site Detect List</h5>
        <small>Only 50 are shown for summary..</small><br>
      </b-form-group>
      <b-card>
      <template slot="header">
         &lt;table 5. Site Detect List&gt;
      </template>
      <b-table hover striped small responsive="sm"  ref="_ch5" show-empty empty-text="not found" :items="rs_ch5" :fields="ch5" :current-page="1" :per-page="rs_ch5.length" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{rs_ch5.length - row.index}}</template>
        <template slot="fqdn" slot-scope="row">{{row.item.fqdn}}</template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | date}}</template>
        <template slot="level" slot-scope="row">{{row.item.level || "-"}}</template>
        <template slot="type" slot-scope="row">{{row.item.type}}</template>
        <template slot="url" slot-scope="row">{{row.item.url}}</template>
      </b-table>
      </b-card>
      <b-form-group>
        <h5>1.5. Site Check List</h5>
        <small>Only 50 are shown for summary..</small><br>
      </b-form-group>
      <b-card>
      <template slot="header">
         &lt;table 5. Site Check List&gt;
      </template>
      <b-table hover striped small responsive="sm"  ref="_ch7" show-empty empty-text="not found" :items="rs_ch7" :fields="ch7" :current-page="1" :per-page="rs_ch7.length" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{rs_ch7.length - row.index}}</template>
        <template slot="site.fqdn" slot-scope="row">{{row.item.fqdn}}</template>
        <template slot="started_at" slot-scope="row">{{row.item.started_at | date}} ~ {{row.item.finished_at | date}}</template>
        <template slot="count" slot-scope="row">{{row.item.page_count || 0}} / {{row.item.ext_count || 0}} / {{row.item.detect_count || 0}}</template>
      </b-table>
      </b-card>
    </div>
</template>

<script>

// import { idle } from '@/f1/service';
import CardBarChart from '../report/CardBarChart';
import moment from 'moment-timezone';
import custom from '@/f1/custom';
import DatePicker from 'vue2-datepicker';
import MainChart from '../report/MainChart';
import { api } from '@/f1/service';
// import { code } from '@/f1/codes';


const default_opt = () => ({
  perPage: 10,
  currentPage: 1, totalRows: 0,
  sk: 'desc', sv: '', skt: '', opt : {}, adv: true
});
let use_dataset = {
  labels: ['use', 'unuse'],
  datasets: [{
      label: 'domain',
      backgroundColor: 'rgba(255,0,0,.3)',
      borderColor: 'transparent',
      data: [15,21]
    }]
}
let detect_dataset = {
  labels: ['Internal Page', 'External Page', 'Detection Page'],
  datasets: [{
      label: 'Detect',
      backgroundColor: 'rgba(255,0,0,.3)',
      borderColor: 'transparent',
      data: [15,25,33]
    }]
}
let result_dataset = {
  labels: ['URL', 'String', 'MD5', 'Regex'],
  datasets: [{
      label: 'Check',
      backgroundColor: 'rgba(255,0,0,.3)',
      borderColor: 'transparent',
      data: [11,17,12,66]
    }]
}
let rule_dataset = {
  labels: ['URL', 'String', 'MD5', 'Regex'],
  datasets: [{
      label: 'Pattern',
      backgroundColor: 'rgba(255,0,0,.3)',
      borderColor: 'transparent',
      data: [78, 81, 80, 45]
    }]
}
const bar_opt = {
  maintainAspectRatio: false,
  legend: { display: false },
  scales: {
    xAxes: [{ display: true, categoryPercentage: 1, barPercentage: 0.5 }],
    yAxes: [{ display: true }]
  }
};
const line_opt = {
  maintainAspectRatio: false,
      legend: {
        display: true
      },
      scales: {
        xAxes: [{
          gridLines: {
            drawOnChartArea: true
          }
        }],
        yAxes: [{
          ticks: {
            beginAtZero: false,
            maxTicksLimit: 7,
            stepSize: Math.ceil(2000 / 5),
            max: 2000
          },
          gridLines: {
            display: true
          }
        }]
      },
      elements: {
        point: {
          radius: 5,
          hitRadius: 10,
          hoverRadius: 4,
          hoverBorderWidth: 3
        }
      }
}
const line_opt2 = {
  maintainAspectRatio: false,
  legend: { display: true },
  scales: {
    xAxes: [
      { gridLines: { drawOnChartArea: true } }
    ],
    yAxes: [
    {
      ticks: {
        beginAtZero: false, maxTicksLimit: 7, stepSize: Math.ceil(20000 / 5), max: 20000 },
        gridLines: { display: true }
      }
    ]
  },
  elements: {
    point: {
      radius: 5,
      hitRadius: 10,
      hoverRadius: 4,
      hoverBorderWidth: 3
    }
  }
}
export default {
  components: { DatePicker, MainChart, CardBarChart },
  data: () => {
    return {
      user : '',
      From: '',
      To: '',
      model:{},
      bar_opt : bar_opt,
      line_opt : line_opt,
      line_opt2 : line_opt2,
      // site_status : site_status,
      rs_ch9 : [],
      rs_ch11 : [],
      rs_ch7 : [],
      rs_ch8 : [],
      rs_ch12 : [],
      rs_ch10 : [],
      rs_ch5 : [],
      use_data : null,
      result_data : null,
      detect_data : null,
      rule_data : null,
      image2_data : null,
      image3_data : null,
      image4_data : null,

      detect : { U : 0, S : 0, R : 0, H : 0 },
      pattern : { system : { U : 0, S : 0, R : 0, H : 0 }, user : { U : 0, S : 0, R : 0, H : 0 } },
      result : { total : 0 },
      site : { use : 0, unuse : 0},
      custom,
      so : default_opt()
    }
  },
  computed: {
    ch5 : function(){ return[
        { key: 'id', label: 'No.', thStyle: 'width: 10%' },
        { key: 'fqdn', label: 'FQDN' },
        { key: 'level', label: 'LEVEL' },
        { key: 'type', label: 'Type' },
        { key: 'url', label: 'URL' },
      ]
    },
    ch8 : function(){ return[
        { key: 'index', label: 'No.', thStyle: 'width: 10%' },
        { key: 'Date', label: 'Date' },
        { key: 'T', label: '점검도메인' },
      ]
    },
    ch9 : function(){ return[
        { key: 'index', label: 'No.'},
        { key: 'Date', label: 'Date' },
        { key: 'H', label: '위험' },
        { key: 'N', label: '의심' },
        { key: 'S', label: '주의' },
        { key: 'W', label: '경고' },
        { key: 'T', label: '총' },
      ]
    },
    ch10 : function(){ return[
        { key: 'name', label: '사이트명' },
        { key: 'fqdn', label: 'URL' },
        { key: 'info', label: 'Code' },
        { key: 'level', label: '위험등급' },
        { key: 'Date', label: '점검일자' },
      ]
    },
    ch11 : function(){ return[
        { key: 'index', label: 'No.', thStyle: 'width: 10%' },
        { key: 'Date', label: 'Date' },
        { key: 'S', label: '의심' },
        { key: 'W', label: '경고' },
        { key: 'H', label: '위험' },
        { key: 'N', label: '주의' },
        { key: 'G', label: '좋음' },
        { key: 'E', label: '에러' },
      ]
    },
    ch12 : function(){ return[
        { key: 'name', label: '사이트명' },
        { key: 'fqdn', label: 'URL' },
        { key: 'info', label: 'Code' },
        { key: 'level', label: '위험등급' },
        { key: 'Date', label: '점검일자' },
      ]
    },
    ch7 : function() { return [
        { key: 'id', label: 'No.', thStyle: 'width: 10%' },
        { key: 'site.fqdn', label: 'FQDN' },
        { key: 'started_at', label: 'Start ~ Finish' },
        { key: 'count', label: 'Count' },
      ]
    },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; }
  },
  methods: {
    printNow(value){ this.print = value; this.$nextTick(() => { window.print(); }); },
    report(){
      let m = {from : moment(this.From).format('YYYY-MM-DD'), to : moment(this.To).format('YYYY-MM-DD') }
        return api.wmds.WMDS({target: 'report', cmd: 'report.web', body : m, limit : 50 }).then(rs => {

          this.user = rs.body.summary.data.group;
	        rs.body.summary.data.result.forEach(r => Object.keys(r).forEach(k => this.result[k] = r[k]));
          rs.body.summary.data.detect.forEach(r => this.detect[r.type] = r.count);
          rs.body.summary.data.pattern.system.forEach(r => this.pattern.system[r.type] = r.count);
          rs.body.summary.data.pattern.user.forEach(r => this.pattern.user[r.type] = r.count);
          this.site = {
            use : _.get(_.filter(rs.body.summary.data.site, { is_alive : 1 })[0], 'count') || 0,
            unuse : _.get(_.filter(rs.body.summary.data.site, { is_alive : 0 })[0], 'count') || 0
          };

          use_dataset.labels = ['use', 'unuse']
          use_dataset.datasets[0].data = [];
          use_dataset.datasets[0].data.push(this.site.use || 0);
          use_dataset.datasets[0].data.push(this.site.unuse || 0);
          this.use_data = _.cloneDeep(use_dataset);

          result_dataset.labels = ['Internal page', 'External page', 'Detection page', 'Error page', 'Binary page']
          result_dataset.datasets[0].data = []
          result_dataset.datasets[0].data.push(_.get(this.result, 'total_page') || 0);
          result_dataset.datasets[0].data.push(_.get(this.result, 'total_ext') || 0);
          result_dataset.datasets[0].data.push(_.get(this.result, 'total_detect') || 0);
          result_dataset.datasets[0].data.push(_.get(this.result, 'total_error') || 0);
          result_dataset.datasets[0].data.push(_.get(this.result, 'total_binary') || 0);
          this.result_data = _.cloneDeep(result_dataset);

          detect_dataset.labels = ['URL', 'String', 'MD5', 'Regex']
          detect_dataset.datasets[0].data = []
          detect_dataset.datasets[0].data.push(this.detect.U || 0);
          detect_dataset.datasets[0].data.push(this.detect.S || 0);
          detect_dataset.datasets[0].data.push(this.detect.H || 0);
          detect_dataset.datasets[0].data.push(this.detect.R || 0);
          this.detect_data = _.cloneDeep(detect_dataset);

          rule_dataset.labels = ['URL', 'String', 'MD5', 'Regex']
          rule_dataset.datasets[0].data = []
          rule_dataset.datasets[0].data.push(this.pattern.system.U || 0 + this.pattern.user.U || 0);
          rule_dataset.datasets[0].data.push(this.pattern.system.S || 0 + this.pattern.user.S || 0);
          rule_dataset.datasets[0].data.push(this.pattern.system.H || 0 + this.pattern.user.H || 0);
          rule_dataset.datasets[0].data.push(this.pattern.system.R || 0 + this.pattern.user.R || 0);
          this.rule_data = _.cloneDeep(rule_dataset);

        // this.image2_data = { labels: rs.rs_result3.map(rs => rs.Date),
        //   datasets: [{ label: '점검도메인', backgroundColor: 'transparent', borderColor: '#00D8FF', pointHoverBackgroundColor: '#fff', data: rs.rs_result3.map(rs => rs.T) }]}

        // this.image3_data = { labels: rs.rs_ch9.map(rs => rs.Date),
        //   datasets: [
        //     { label: '의심', backgroundColor: 'transparent', borderColor: '#FF0000', pointHoverBackgroundColor: '#fff', data: rs.rs_ch9.map(rs => rs.S) },
        //     { label: '경고', backgroundColor: 'transparent', borderColor: '#FF5E00', pointHoverBackgroundColor: '#fff', data: rs.rs_ch9.map(rs => rs.W) },
        //     { label: '위험', backgroundColor: 'transparent', borderColor: '#FFBB00', pointHoverBackgroundColor: '#fff', data: rs.rs_ch9.map(rs => rs.H) },
        //     { label: '주의', backgroundColor: 'transparent', borderColor: '#FFE400', pointHoverBackgroundColor: '#fff', data: rs.rs_ch9.map(rs => rs.N) }]
        // }

        // this.image4_data = { labels: rs.rs_result2.map(rs => rs.Date),
        //     datasets: [
        //       { label: '의심', backgroundColor: 'transparent', borderColor: '#FF0000', pointHoverBackgroundColor: '#fff', data: rs.rs_result2.map(rs => rs.S) },
        //       { label: '경고', backgroundColor: 'transparent', borderColor: '#FF5E00', pointHoverBackgroundColor: '#fff', data: rs.rs_result2.map(rs => rs.W) },
        //       { label: '위험', backgroundColor: 'transparent', borderColor: '#FFBB00', pointHoverBackgroundColor: '#fff', data: rs.rs_result2.map(rs => rs.H) },
        //       { label: '주의', backgroundColor: 'transparent', borderColor: '#FFE400', pointHoverBackgroundColor: '#fff', data: rs.rs_result2.map(rs => rs.N) },
        //       { label: '좋음', backgroundColor: 'transparent', borderColor: '#00D8FF', pointHoverBackgroundColor: '#fff', data: rs.rs_result2.map(rs => rs.G) },
        //       { label: '오류', backgroundColor: 'transparent', borderColor: '#EAEAEA', pointHoverBackgroundColor: '#fff', data: rs.rs_result2.map(rs => rs.E) },]
        // }
        // this.model = rs.body;
        // this.rs_ch9 = rs.rs_ch9;
        // this.rs_ch11 = rs.rs_result2;
        // this.rs_ch8 = rs.rs_result3;
        // this.rs_ch12 = rs.rs_s_result;
        // this.rs_ch10 = rs.rs_wnh_result;
        this.rs_ch5 = rs.body.recent.data.detect;
        this.rs_ch7 = rs.body.recent.data.result;
        this.$refs._ch5 ? this.$refs._ch5.refresh() : ''
        this.$refs._ch7 ? this.$refs._ch7.refresh() : ''

        console.info("wsfinder report done");
        this.$toastr.i("done", "report loading")

        // return this.model;
      }).catch(e => { console.log(e); this.$toastr.e(e) });
    },
    reset() { try { this.refresh(); } catch(e){ this.$toastr.e(e); } },
    hideList: function(e) { this.show = !e; console.log('report.vue', 'got event (list show/hide)', !e ? 'show' : 'hide') }
  },
  created: function() {   console.log('report.vue', 'created'); },
  destroyed: function() {
    console.log('report.vue', 'destroyed');
  },
  mounted: function() {
    this.From = location.hostname == "localhost" ? moment().add(-1, 'M').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
    this.To = moment().format('YYYY-MM-DD');
    this.report();
    console.log('report.vue', 'mounted'); },
}
</script>
